import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axiosInstance";
import LoadingSpinner from "../components/LoadingSpinner";
import { useParams } from "react-router-dom";
import { FaCopy } from "react-icons/fa";

const EditNotificationTemplate = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    title: "",
    templateKey:"",
    body: "",
    description: "",
    variables:[]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };
  const copyToClipboard = (variable) => {
    navigator.clipboard.writeText(variable).then(() => {
      toast.success(`Copied: ${variable}`);
    }, (err) => {
      console.error('Could not copy text: ', err);
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await axiosInstance.put(`/notification-template/update/${formValues.templateKey}`, formValues);
      if (res) {
        toast.success("Template updated successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
console.log(formValues.variables)
  useEffect(() => {
    if (id) {
      const fetchTemplate = async () => {
        try {
          setLoading(true);
          const res = await axiosInstance.get(`/notification-template/${id}`);
          if (res?.data) {
            setFormValues({
              templateKey: res.data.data.template.data.template.templateKey,
              variables:res.data.data.template.data.template.variables,
              title:res.data.data.template.data.template.title,
              description:res.data.data.template.data.template.description ||"",
            });
            console.log({
              title: res.data.data.template.data.template.templateKey,
              variables:res.data.data.template.data.template.variables
            })
          }
        } catch (error) {
          console.log(error)
          toast.error(error?.response?.data?.message || "Failed to fetch template");
        } finally {
          setLoading(false);
        }
      };

      fetchTemplate();
    }
  }, [id]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Edit Notification Template</h1>
      {loading && <LoadingSpinner />}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-md shadow-md">
      <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Key</label>
          <input
            type="text"
            name="title"
            value={formValues.templateKey}
             onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg text-gray-700 shadow border-2 border-gray-400 focus:border-blue-500 focus:outline-none;
 bg-gray-100 text-gray-500 cursor-not-allowed"
            placeholder="Enter Template Title"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Title</label>
          <input
            type="text"
            name="title"
            value={formValues.title}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Template Title"
          />
        </div>

        {/* <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Body</label>
          <textarea
            name="body"
            value={formValues.body}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Notification Body"
            rows={5}
          />
        </div> */}

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Body</label>
          <textarea
            name="description"
            value={formValues.description}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Description (optional)"
            rows={3}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
        {formValues.variables &&formValues.variables.length>0&& formValues?.variables.map((variable, index) => (
                  <div className="pb-2  flex items-center" key={index}>
                    <div className="flex-grow ">
                      <label className="m-1 input-label-bold">Variable {index + 1}</label>
                      <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg text-gray-700 shadow border-2 border-gray-400 focus:border-blue-500 focus:outline-none;
 bg-gray-100 text-gray-500 cursor-not-allowed"
                        value={variable}
                        readOnly
                      />
                    </div>
                    <div className="p-2 mt-2 cursor-pointer">
             <FaCopy color="#20bb83" 
                      onClick={() => copyToClipboard(variable)}
                    />

</div> 
                  </div>
                ))}
                </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
};

export default EditNotificationTemplate;
